import ProductsCategoryList from 'gatsby-theme-husky/src/components/Products/ProductsCategoryList/ProductsCategoryList';

import './ProductsCategoryListOverride.scss';

export default ProductsCategoryList;
